import ModalComponent from "src/core/components/modal/modal.component";
import type { ActionMode, DaysActive, TimerProfileFormValues } from "../../components/types";
import { TimerProfileForm } from "./timer-profile-form.component";

type ZoneOption = {
  id: number;
  name: string;
};

type TimerProfileFormModalProps = {
  isOpen: boolean;
  mode: "add" | "edit";
  values: TimerProfileFormValues;
  onChange: (values: TimerProfileFormValues) => void;
  errors: Record<string, string>;
  daysOptions: DaysActive[];
  actionModeOptions: ActionMode[];
  zoneOptions: ZoneOption[];
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onTouchField?: (fieldName: string) => void;
};

export function TimerProfileFormModal({
  isOpen,
  mode,
  values,
  onChange,
  errors,
  daysOptions,
  actionModeOptions,
  zoneOptions,
  isSubmitting,
  onClose,
  onSubmit,
  onTouchField,
}: TimerProfileFormModalProps) {
  if (!isOpen) return null;

  return (
    <ModalComponent
      showModal={isOpen}
      handleClose={onClose}
      headerTitle={mode === "add" ? "Add Profile" : "Edit Profile"}
      actionConfig={[
        {
          label: "Save",
          event: onSubmit,
          variant: "primary" as const,
          disabled: isSubmitting,
        },
      ]}
      size="lg"
    >
      <TimerProfileForm
        values={values}
        onChange={onChange}
        errors={errors}
        daysOptions={daysOptions}
        actionModeOptions={actionModeOptions}
        zoneOptions={zoneOptions}
        isSubmitting={isSubmitting}
        onTouchField={onTouchField}
      />
    </ModalComponent>
  );
}